module.exports = __webpack_public_path__ + "img/icon-warning-drivingconditions-2.d00a04be.svg";